import React, { useRef, useState } from 'react'
import BillDetail from '../Modal/BillDetail';
import DateFormat from './DateFormat';
import { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { DownloadTableExcel } from 'react-export-table-to-excel';

const CustomerHistory = ({ customerHistory, discountTotal, totalSum, selectedOutlet }) => {
    let url = process.env.REACT_APP_BASE_URL;
    const tableRef = useRef(null);

    let navigate = useNavigate();
    const [token, setToken] = useState("");
    // const [billInfo, setBillInfo] = useState({});
    // const [billInfoList, setBillInfoList] = useState([]);
    const [billData, setBillData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [billID, setBillID] = useState();

    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        let tokenCheck = sessionStorage.getItem("token");
        if (!tokenCheck) {
            navigate('/')
        } else {
            setToken(sessionStorage.getItem("token"))
        }
    }, [])

    // const handleBillInfo = async (bill, date) => {
    //     try {
    //         const convertDate = new Date(date).toISOString().substring(0, 10);

    //         const { data } = await axios.post(`${url}/billinfo`, {
    //             bill_no: bill,
    //             Date: convertDate,
    //             Outlet_Name: selectedOutlet,
    //             token: token,
    //         });

    //         if (data) {
    //             setBillInfoList(data.details || []);
    //             setBillInfo(data);
    //             setShowModal(true);
    //         }
    //     } catch (error) {
    //         console.log("Bill error", error);
    //     }
    // };

    const handleBillInfo = async (bill, date) => {
        try {
            const convertDate = new Date(date).toISOString().substring(0, 10);

            const { data } = await axios.post(`${url}/billinfo`, {
                bill_no: bill,
                Date: convertDate,
                Outlet_Name: selectedOutlet,
                token: token,
            });

            if (data) {
                setBillData(data || []);
                setShowModal(true);
            }
        } catch (error) {
            console.log("Bill error", error);
        }
    };

    return (
        <div className="table-customer-history">
            <DownloadTableExcel
                filename="customer_portal"
                sheet="CustomerHistory"
                currentTableRef={tableRef.current}>
                <button className="export">
                    Export
                </button>
            </DownloadTableExcel>
            <div className='customer-table-title'>
                <h5>Customer History</h5>
            </div>
            <div className="table-history-responsive table-data-customer">
                <table className="table-customer" ref={tableRef}>
                    <thead>
                        <tr className='position-sticky'>
                            <th>Bill</th>
                            <th>Customer</th>
                            <th>Date</th>
                            <th>Discount Amount</th>
                            <th>Discount Type</th>
                            <th>Mode</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    {customerHistory.map((item) => (
                        <tr>
                            <td >
                                <button
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => {
                                        handleBillInfo(item.Bill, item.Date)
                                        setBillID(item.bill_id)
                                    }}
                                >
                                    {item.Bill}
                                </button>
                            </td>
                            <td>{item.Customer}</td>
                            <td>
                                <DateFormat date={item.Date} /></td>
                            <td>{item.DiscountAmt}</td>
                            <td>{item.DiscountType}</td>
                            <td>{item.Mode}</td>
                            <td>{item.Total}</td>
                        </tr>
                    ))
                    }
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Discount: <span>{discountTotal}</span> </td>
                            <td></td>
                            <td></td>
                            <td>Total: {totalSum}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>


            {/* <BillDetail
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                billInfo={billInfo}
                billInfoList={billInfoList}
                selected={selectedOutlet}
            /> */}
            <BillDetail
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                data={billData}
                selected={selectedOutlet}
                billID={billID}
            />
        </div>
    )
}

export default CustomerHistory